import { Controller, useFormContext } from "react-hook-form";

import DeleteIcon from "@mui/icons-material/Delete";

import { IconButton, Tooltip } from "@mui/material";

import FormField from "../../../components/FormField";
import LocationFilter from "../../../components/filters/LocationFilter";
import NumberTextfield from "../../../components/NumberTextfield";
import IIndicationsRequest from "../types/IIndicationsRequest";

const getError = (errors: any, key: string) => {
  const record = errors[key];

  if (!record) return undefined;

  return record.message;
};

const OriginPrice = ({
  indicationIndex,
  originPriceIndex,
  deleteIndication,
  disabled,
}: {
  indicationIndex: number;
  originPriceIndex: number;
  deleteIndication: () => void;
  disabled?: boolean;
}) => {
  const form = useFormContext<IIndicationsRequest>();

  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: 10,
      }}
    >
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          alignItems: "flex-start",
          gap: 10,
        }}
      >
        <div
          style={{
            width: "50%",
          }}
        >
          {/* {getError(form.formState.errors, `indications[${indicationIndex}`)} */}
          <Controller
            control={form.control}
            name={`indications.${indicationIndex}.prices.${originPriceIndex}.origin`}
            render={({ field }) => (
              <FormField
                label="Competitor Origin"
                disabled={disabled}
                errorMessage={getError(
                  form.formState.errors,
                  `indications[${indicationIndex}].prices[${originPriceIndex}].origin`
                )}
              >
                <LocationFilter
                  size="small"
                  disabled={disabled}
                  value={field.value}
                  setValue={field.onChange}
                />
              </FormField>
            )}
          />
        </div>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <Controller
            control={form.control}
            name={`indications.${indicationIndex}.priceType`}
            render={({ field }) => (
              <>
                {field.value === "single" && (
                  <Controller
                    control={form.control}
                    name={`indications.${indicationIndex}.prices.${originPriceIndex}.fobPrice`}
                    render={({ field: field1 }) => (
                      <FormField
                        label="FOB Price"
                        disabled={disabled}
                        errorMessage={getError(
                          form.formState.errors,
                          `indications[${indicationIndex}].prices[${originPriceIndex}].fobPrice`
                        )}
                      >
                        <NumberTextfield
                          currency
                          disabled={disabled}
                          size="small"
                          fullWidth
                          placeholder="Enter single price"
                          value={field1.value}
                          setValue={field1.onChange}
                        />
                      </FormField>
                    )}
                  />
                )}
                {field.value === "range" && (
                  <>
                    <Controller
                      control={form.control}
                      name={`indications.${indicationIndex}.prices.${originPriceIndex}.fobMinPrice`}
                      render={({ field: field1 }) => (
                        <FormField
                          label="Min FOB price"
                          disabled={disabled}
                          errorMessage={getError(
                            form.formState.errors,
                            `indications[${indicationIndex}].prices[${originPriceIndex}].fobMinPrice`
                          )}
                        >
                          <NumberTextfield
                            currency
                            disabled={disabled}
                            size="small"
                            fullWidth
                            placeholder="Min FOB price"
                            value={field1.value}
                            setValue={field1.onChange}
                          />
                        </FormField>
                      )}
                    />

                    <Controller
                      control={form.control}
                      name={`indications.${indicationIndex}.prices.${originPriceIndex}.fobMaxPrice`}
                      render={({ field: field1 }) => (
                        <FormField
                          label="Max FOB price"
                          disabled={disabled}
                          errorMessage={getError(
                            form.formState.errors,
                            `indications[${indicationIndex}].prices[${originPriceIndex}].fobMaxPrice`
                          )}
                        >
                          <NumberTextfield
                            currency
                            disabled={disabled}
                            size="small"
                            fullWidth
                            placeholder="Max FOB price"
                            value={field1.value}
                            setValue={field1.onChange}
                          />
                        </FormField>
                      )}
                    />
                  </>
                )}
              </>
            )}
          />
        </div>
      </div>
      <Tooltip title="Delete origin price">
        <div style={{ paddingTop: 15 }}>
          <IconButton
            style={{
              height: 32,
              width: 32,
              borderRadius: 4,
              opacity: disabled ? 0.5 : 1,
            }}
            disabled={disabled}
            onClick={() => deleteIndication()}
          >
            <DeleteIcon
              color="error"
              style={{
                fontSize: 24,
                margin: 0,
                padding: 0,
              }}
            />
          </IconButton>
        </div>
      </Tooltip>
    </div>
  );
};

export default OriginPrice;
